import { render, staticRenderFns } from "./RiskAssessmentList.vue?vue&type=template&id=7dbf2861&scoped=true&"
import script from "./RiskAssessmentList.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf2861",
  null
  
)

export default component.exports